export function ticketMedioComprador(c) {
  const pedidos = Number(c.pedidos_pagos);
  if (!Number.isFinite(pedidos) || pedidos <= 0) return null;
  const receita = Number(c.receita_total);
  if (!Number.isFinite(receita)) return null;
  return receita / pedidos;
}

export function tempoMedioEntreComprasDias(c) {
  const pedidos = Number(c.pedidos_pagos);
  if (!Number.isFinite(pedidos) || pedidos <= 1) return null;
  const first = Date.parse(c.primeira_compra);
  const last = Date.parse(c.ultima_compra);
  if (Number.isFinite(first) && Number.isFinite(last) && last >= first) {
    return (last - first) / 86_400_000 / (pedidos - 1);
  }
  const span = Number(c.dias_entre_compras);
  if (!Number.isFinite(span) || span < 0) return null;
  return span / (pedidos - 1);
}

export function formatDuracaoDias(days) {
  if (days == null || Number.isNaN(days) || days < 0) return '—';
  if (days < 1 / 24) {
    const mins = Math.round(days * 24 * 60);
    return mins <= 0 ? '<1 min' : `${mins} min`;
  }
  if (days < 1) return `${(days * 24).toFixed(1)}h`;
  return `${days.toFixed(1)}d`;
}
